'use client';

import { Image, type ImageProps } from '@chakra-ui/react';
import type React from 'react';

import { useI18n } from '@/__generated__/i18n.next';

/** The logo sized by its height; its intrinsic size reserves its width before the image loads. */
export const ExercodeLogo: React.FC<{ h: ImageProps['h'] }> = ({ h }) => {
  const t = useI18n();
  // The intrinsic size of public/language-neutral/images/exercode.svg.
  return (
    <Image
      alt={t.core.title()}
      h={h}
      htmlHeight={556}
      htmlWidth={3308}
      src="/language-neutral/images/exercode.svg"
      w="auto"
    />
  );
};
